import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const CouponFetch = loadable(() => pMinDelay(import('./CouponFetch'), 300), {
  fallback: <Loading />
});

const AsyncCouponFetch = props => {
  let title = 'Kupon Getir | Öneri Kuponuna Hemen Oyna | Bilyoner';
  let description = "Telefonunu Salla İddaa Kuponun Gelsin! Risk Seviyesine Göre Kupon Önerisi Kupon Getir ile Bilyoner'de! Ne Varsa Bilyoner'de Var!";

  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      },
      title,
      description,
      script: [
        {
          defer: 'defer',
          src: '/public/thirdParty/swiper/swiper.js'
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/swiper/swiper.css'
        }
      ]
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <CouponFetch { ...props } />
    </ApplicationLayout>
  );
};

AsyncCouponFetch.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncCouponFetch;
